import { useParams } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { API } from '@/shared/api';
import { Project } from '@/shared/types/Project';

import { RQ_PROJECT_KEY } from '../lib/constants/common';

const useProjectQuery = <TData,>(projectId: string | undefined, enabled: boolean, select?: (data: Project) => TData) =>
  useQuery({
    enabled: enabled && Boolean(projectId),
    gcTime: 0,
    queryFn: async () => {
      if (!projectId) {
        return Promise.reject('projectId is not provided');
      }

      return await API.getProjectById(projectId);
    },
    queryKey: [...RQ_PROJECT_KEY, projectId],
    select,
  });

export const useGetProjectById = <TData = Project,>(
  projectId: string | undefined,
  enabled = true,
  select?: (data: Project) => TData,
) => useProjectQuery(projectId, enabled, select);

export const useGetProject = <TData = Project,>(select?: (data: Project) => TData) => {
  const { projectId } = useParams();

  return useProjectQuery(projectId, Boolean(projectId), select);
};
